import { render } from "./icon-swedbank.vue?vue&type=template&id=7b836e39"
import script from "./icon-swedbank.vue?vue&type=script&lang=js"
export * from "./icon-swedbank.vue?vue&type=script&lang=js"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__